import { APIDateFormats } from '../../../../utils/Date.js';
import moment from 'moment';
import { SupportTicketMapper } from '../SupportTicketMapper.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

class PickupSupportTicketMapper {
  static createModelFromResponse(response) {
    return {
      ...SupportTicketMapper.createModelFromResponse(response),
      shipmentReference: response.shipment_reference,
      collectionDate: response.pickup.collection_date,
      additionalComments: response.pickup.additional_comments
    };
  }
  static createApiPayload(_ref) {
    let {
      shipmentReference,
      collectionDate,
      additionalComments
    } = _ref;
    return {
      shipment_reference: shipmentReference,
      pickup: {
        collection_date: moment(collectionDate).format(APIDateFormats.date),
        additional_comments: additionalComments
      }
    };
  }
}

export { PickupSupportTicketMapper };
//# sourceMappingURL=PickupSupportTicketMapper.js.map
